<template>
    <b-card class="crm-schedule">
        <b-card-header class="assets-filter">
            <b-row class="mt-2 flex-nowrap">
                <b-col lg="9" xl="10" md="9" class="search-field">
                    <div class="input-group">
                        <input
                        id="search-task"
                            type="text"
                            class="form-control"
                            v-model="query"
                            :placeholder="
                                crm
                                    ? $translate('search_tasks')
                                    : $translate('search_assets')
                            "
                        />
                        <div class="input-group-prepend bg-transparent">
                            <i class="mdi mdi-magnify"></i>
                        </div>
                    </div>
                </b-col>
                <b-col lg="3" xl="2" md="3" class="pt-1">
                    <div class="d-flex">
                        <b-button
                            id="toggle-filter-btn"
                            variant="blue-button"
                            class="me-2 d-flex"
                            @click="toggle_filters = !toggle_filters"
                        >
                            {{ $translate('filters') }}
                            <b-icon
                                class="mt-1 ms-1"
                                :icon="
                                    'chevron-' +
                                    (toggle_filters ? 'up' : 'down')
                                "
                                variant="dark"
                            ></b-icon>
                        </b-button>
                        <b-button
                            id="reset-filter-btn"
                            variant="blue-button"
                            @click="resetFilters"
                            v-b-tooltip.hover
                            :title="$translate('reset_filters')"
                        >
                            <b-icon icon="arrow-repeat" variant="dark"></b-icon>
                        </b-button>
                    </div>
                </b-col>
            </b-row>
            <!-- <b-row class="mt-3">
                
            </b-row> -->

            <schedule-query-builder
                v-show="toggle_filters"
                v-model="filters"
                :user="user"
                :crm="crm"
                :officers="officers"
                :roles="roles"
                :crm-setting-value="crmSettingValue"
            />
        </b-card-header>
        <b-overlay :show="!loaded" rounded="sm">
            <b-card-body>
                <div class="m-2 font-weight-bold">
                    {{ selectedMonthEventsText }}
                </div>
                <FullCalendar
                    :options="calendarOptions"
                    ref="calendar"
                    class="full-calendar w-100 h-100"
                />
            </b-card-body>
        </b-overlay>
    </b-card>
</template>
  
<script>
import _ from 'lodash'
import ScheduleQueryBuilder from './ScheduleQueryBuilder.vue'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import listPlugin from '@fullcalendar/list'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import moment from 'moment'
import esLocale from '@fullcalendar/core/locales/es'
import schedulerMixins from '../../mixins/schedulerMixins'

export default {
    components: {
        FullCalendar,
        ScheduleQueryBuilder,
    },
    props: ['crm', 'roles', 'user', 'officers', 'crmSettingValue'],
    mixins: [schedulerMixins],
    data() {
        return {
            query: '',
            loaded: false,
            selectedMonthEventsText: '',
            toggle_filters: false,
            calendarOptions: {
                plugins: [
                    dayGridPlugin,
                    listPlugin,
                    timeGridPlugin,
                    interactionPlugin,
                ],
                headerToolbar: {
                    left: '',
                    center: 'prev today next',
                    right: 'dayGridMonth dayGridWeek dayGridDay listDay',
                },
                buttonText: {
                    today: 'This Month',
                },
                datesSet: this.updateCustomButton,
                initialView: 'dayGridMonth',
                events: [], // Initialize events as an empty array
                eventContent: this.renderEventContent,
                selectable: true,
                selectMirror: true,
                dayMaxEvents: true,
                weekends: true,
                locale:
                    this.getLocale(localStorage.getItem('language')) || 'en',
            },
            filters: {
                customer_id: null,
                type_id: null,
                default_engineer_id: this.user.id,
                role_id: null,
                next_service_from: null,
                next_service_to: null,
                last_service_from: null,
                last_service_to: null,
                warranty_from: null,
                warranty_to: null,
            },
            searchTimeout: null,
        }
    },
    computed: {
        assets() {
            return this.$store.state.assets.assets
        },
        assetSchedules() {
            let data = this.$store.state.assetScheduleStore.assetSchedulesNotPaginated
            data = data.map((item) => {
                return {
                    ...item.asset,
                    ...item,
                    name: item.asset.name,
                    schedule_name: item.name,
                }
            })
            console.log("data=", data)
            return data
        },
        
    },

    mounted() {
        const calendarApi = this.$refs.calendar.getApi()
        calendarApi.on('eventClick', this.handleEventClick)
        calendarApi.on('dateClick', this.handleDateClick)
        this.doSearch()
    },
    watch: {
        'crmSettingValue.type_id': function (type_id) {
            if (this.crm) {
                this.$set(this.filters, 'type_id', type_id || null)
            }else {
                this.$set(this.filters, 'type_id', type_id || null)
            }
        },
        filters: {
            handler: function () {
                
                this.doSearch()
            },
            deep: true,
        },
        assetSchedules: {
            handler: function (val) {
                this.scheduleData()
            },
            deep: true,
        },
        query: function (query) {
            this.$router.push({ query: { query } })
            // this.doSearch()
        },
    },
    created() {},

    methods: {
        getLocale(language) {
            if (language == 'es') {
                return esLocale
            }
        },
        handleDateClick(info) {
            this.$store.commit('assets/updateScheduleDate', info.dateStr)
            if (this.crm) {
                this.$router.push(`/ams/crm/0`)
            } else {
                this.$router.push(`/ams/assets/0`)
            }
        },
        resetFilters() {
            this.filters = {
                customer_id: null,
                type_id: null,
                default_engineer_id: null,
                role_id: null,
                next_service_from: null,
                next_service_to: null,
                last_service_from: null,
                last_service_to: null,
                warranty_from: null,
                warranty_to: null,
            }
            // this.doSearch()
        },
        handleEventClick(eventClickInfo) {
            const type_id = this.crmSettingValue.type_id
            const eventTypeId = eventClickInfo.event.extendedProps.type_id
            const eventId = eventClickInfo.event.extendedProps.eventId
            if (eventTypeId == type_id) {
                this.$router.push(`/ams/crm/${eventId}`)
            } else {
                this.$router.push(`/ams/assets/${eventId}`)
            }
        },
        async doSearch() {
            try {
                await this.pureSearch()
                this.$nextTick(() => {
                    this.updateCustomButton()
                })
            } catch (err) {
                console.error('loading error', err);
            }
        },
        scheduleData() {

           
            let assets
            const type_id = this.crmSettingValue.type_id
            let data = this.assetSchedules;
            console.log('data==', data)
            if (this.crm && data) {
                assets = data.filter(x => x.type_id == type_id)
            } else if(data){
                assets = data.filter(x => x.type_id !== type_id)
            }
            if(data.length > 0){

                console.log('this calender is calling !!!');
                this.calendarOptions.events = []
                this.calendarOptions.events = this.getAssetSchedulerData(assets)

                console.log('calendar events are =========', this.calendarOptions.events);
            }else{
                this.calendarOptions.events = [];
            }
        },
        renderEventContent(eventInfo) {
            const type_id = this.crmSettingValue.type_id
            const customerName = eventInfo.event.extendedProps.customerName
            const agentName = eventInfo.event.extendedProps.agentName
            const typeName = eventInfo.event.extendedProps.typeName
            console.log('data==', eventInfo.event.extendedProps)
            const scheduleName = eventInfo.event.extendedProps.schedule_name
            const nextDate =
                eventInfo.event.extendedProps.nextDate != null
                    ? eventInfo.event.extendedProps.nextDate
                    : ''
            const eventTitle = eventInfo.event.title
            const currentDate = new Date()
            const due_date = new Date(nextDate)
            let eventColor
            if (due_date > currentDate) {
                eventColor = 'green'
            } else {
                eventColor =
                    eventInfo.event.extendedProps.type_id === type_id
                        ? 'blue'
                        : 'red'
            }

            const htmlContent = `
            <div style="background-color: ${eventColor}; color:white;">
            <div> ${this.$translate('event')}: ${eventTitle}</div>
          <div>${this.$translate('next_date')}: ${nextDate}</div>
          <div>${this.$translate('customer')}: ${customerName}</div>
          <div>${this.$translate('agent')}: ${agentName}</div>
          <div>${this.$translate('type')}: ${typeName}</div>
          <div>${this.$translate('schedule_name')}: ${scheduleName}</div>
          <!-- Add any additional content or styling here -->
        </div>
      `

            return { html: htmlContent }
        },
        updateCustomButton() {
            const calendarApi =
                this.$refs.calendar && this.$refs.calendar.getApi()
            if (!calendarApi) return
            const currentEvents = calendarApi.getEvents()
            const startOfMonth = moment.utc(
                calendarApi.currentData.dateProfile.currentRange.start
            )
            const endDate = moment.utc(
                calendarApi.currentData.dateProfile.currentRange.end
            )
            const formatteStartdDate = moment(
                startOfMonth.toISOString()
            ).format('YYYY-MM-DD')
            const newEndDate = new Date(endDate)
            newEndDate.setDate(newEndDate.getDate() - 1)
            const formattedEndDate = moment(newEndDate.toISOString()).format(
                'YYYY-MM-DD'
            )
            const title = calendarApi.currentData.viewSpec.buttonTextDefault
            const selectedMonthDateTitle = calendarApi.currentData.viewTitle
            this.calendarOptions.buttonText.today = this.getLabel(title)
            const selectedMonthEvents = currentEvents.filter(event => {
                const eventStartDate = moment(event.start.toISOString()).format(
                    'YYYY-MM-DD'
                )
                return (
                    eventStartDate >= formatteStartdDate &&
                    eventStartDate <= formattedEndDate
                )
            })
            const selectedMonthEventsCount = selectedMonthEvents.length
            this.selectedMonthEventsText = `${selectedMonthDateTitle} ${this.$translate(
                'showing'
            )} ${selectedMonthEventsCount}  ${this.$translate('events')}`
            // this.calendarOptions.customButtons.custom2.text = `${formattedStartDate} - ${formattedEndDate} Showing ${selectedMonthEventsCount} events)`;
        },
        getLabel(title) {
            const lowerTitle = title && title.toLowerCase()
            switch (lowerTitle) {
                case this.$translate('month').toLowerCase():
                    return this.$translate('this_month')
                case this.$translate('week').toLowerCase():
                    return this.$translate('this_week')
                case this.$translate('day').toLowerCase():
                    return this.$translate('today')
                case this.$translate('list').toLowerCase():
                    return this.$translate('today')
                default:
                    return this.$translate('this_month')
            }
        },

        // doSearch(){}
        async pureSearch() {
            try {
                this.loaded = false
                const {
                    query,
                    filters,
                    crm,
                    crmSettingValue: { type_id },
                } = this
                
             
                let from_calendar = true;
                if (crm) {
                    console.log('type_id-', type_id)
                    await this.$store.dispatch('assetScheduleStore/fetch_all_schedules', {filters: {...filters, type_id, from_calendar}, crm})
                } else if(type_id) {
                    await this.$store.dispatch('assetScheduleStore/fetchAssetSchedules', {filters: {...filters, type_id: filters.type_id, from_calendar}})
                }
                await this.$nextTick()
                this.scheduleData()
            } catch (err) {
                console.error('loading error', err)
            } finally {
                this.loaded = true
                this.loading = false
            }
        },
    },
    destroyed(){
        this.calendarOptions.events = []
    }
}
</script>
  